import script from "./base-big5-results-chart.vue?vue&type=script&setup=true&lang=js"
export * from "./base-big5-results-chart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__